class Card {
  constructor(jq, document) {
    this.jQuery = jq
    this.document = document
  }

  unblur() {
    setTimeout(() => {
      const blurOne = this.document.querySelector(".js-blur-one")
      if (blurOne) {
        blurOne.style.filter = "blur(0px)"
        this.document.querySelector(".qr-overlay").classList.add("removed")
        this.document
          .querySelector(".qr-overlay-qrcode")
          .classList.add("removed")
      }
    }, 300)
  }

  verifyClickCollect() {
    let log_id = this.jQuery(
      "form.edit_sigilium_logger .sigilium_logger_id input"
    ).val()

    this.jQuery
      .ajax({
        url: "/sigilium/loggers/" + log_id,
        type: "PATCH",
        data: {
          sigilium_logger: {
            id: log_id,
            js_verified: "1",
          },
        },
      })
      .done(() => {})
  }

  logCardClicks() {
    var form = this.jQuery("form.new_sigilium_card_logger ")
    var announcement_id = this.jQuery(
      'input[name="sigilium_card_logger[announcement_id]"]',
      form
    ).val()
    var signature_id = this.jQuery(
      'input[name="sigilium_card_logger[signature_id]"]',
      form
    ).val()
    var form_data = {
      announcement_id: announcement_id,
      signature_id: signature_id,
    }

    const jQuery = this.jQuery
    this.jQuery("a.js-tag-link").click((e) => {
      let href = jQuery(this).prop("href")
      var tag_name = jQuery(this).data("tag")
      form_data["link_href"] = href
      form_data["link_type"] = tag_name

      jQuery
        .ajax({
          url: form.prop("action"),
          type: "POST",
          dataType: "json",
          data: {
            sigilium_card_logger: form_data,
          },
        })
        .done(() => {})

      const newTab = jQuery(this).prop("target") == "_blank"
      console.log("newTab", newTab)
      setTimeout(() => {
        if (newTab) {
          e.preventDefault()
          console.log("href", href)
          const open = window.open(href)
          console.log("open ", open)
          // On iOs open is blocked
          if (open == null || typeof open == "undefined") {
            window.location = href
          }
        } else {
          // window.location = href
        }
      }, 150)
    })
  }
}

export { Card }
